export default __webpack_public_path__ + "static/media/f-logo.5b4225fa.png";